import React, { Component } from "react";
import { MentionsInput, Mention } from "react-mentions";
import Picker, { SKIN_TONE_LIGHT } from "emoji-picker-react";

export default class PoAddComment extends Component {
    state = {
        value: "",
        openEmoji: false
    };

    onEmojiClick = (event, emojiObject) => {
        let value = this.props.value + emojiObject.emoji
        this.props.onChange({ value });
    };

    handleChange = (event) => {
        const value = event.target.value;

        const regex = /[^{}]+(?=})/g;
        const mentions = value.match(regex) || [];

        if (this.props.onChange) {
            this.props.onChange({ value, mentions });
        }
    };

    render() {
        const { users = [], placeholder = "Add a comment...", disabled = false, t } = this.props;
        const { value, openEmoji } = this.state;

        const defaultStyle = {
            control: {
                backgroundColor: "#fdfbfb",
                fontSize: 12,
                fontWeight: "normal",
                borderRadius: "14px",
                height: "7em",
                maxHeight: "7em",
            },
            highlighter: {
                overflow: "hidden",
                maxHeight: "7em",
            },
            input: {
                margin: 0,
                overflow: "auto",
            },
            "&multiLine": {
                control: {
                    border: "1px solid silver",
                    borderRadius: "14px",
                },
                highlighter: {
                    padding: 9,
                },
                input: {
                    padding: 9,
                    minHeight: 3,
                    outline: 0,
                    border: 0,
                    borderRadius: "14px",
                },
            },
            suggestions: {
                bottom: 0,
                top: "unset",
                list: {
                    backgroundColor: "white",
                    border: "1px solid rgba(0,0,0,0.15)",
                    fontSize: 12,
                },
                item: {
                    padding: "5px 15px",
                    borderBottom: "1px solid rgba(0,0,0,0.15)",
                    "&focused": {
                        backgroundColor: "#cee4e5",
                    },
                },
            },
        };


        const defaultMentionStyle = {
            backgroundColor: "#cee4e5",
            // color: "#0073aa",
            // borderRadius: "4px",
            // padding: "2px 4px"
        };

        return (
            <div className="comment-input-wrapper">
                <div className="mentions-wrapper">
                    <MentionsInput
                        value={this.props.value}
                        onChange={this.handleChange}
                        style={defaultStyle}
                        placeholder={t ? t("add_comment_metion") : placeholder}
                        disabled={disabled}
                    >
                        <Mention
                            markup="*?¿$·__display__*?¿$· ?%¿{__id__}?%¿"
                            data={users}
                            style={defaultMentionStyle}
                        />
                    </MentionsInput>

                    <span
                        onClick={() => this.setState({ openEmoji: !openEmoji })}
                        className="icon-smileys-people icons-front-module blue emoji-toggle"
                        style={{ cursor: "pointer" }}
                    />
                </div>

                {openEmoji && (
                    <div className="emoji-picker-container">
                        <Picker
                            skinTone={SKIN_TONE_LIGHT}
                            onEmojiClick={this.onEmojiClick}
                        />
                    </div>
                )}
            </div>
        );
    }
}
